import styled from 'styled-components';
import { color, container, fontWeight, radius, spacing } from '../../../theme';

export const StyledOfferBottomBarPageNav = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  padding: ${spacing('md')} ${spacing('lg')};

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin-top: 1.25rem;
  }

  a {
    color: ${color('text_default_inverse')};
    display: inline-flex;
    align-items: center;
    transition: 0.3s;

    &::before {
      content: '';
      display: block;
      width: ${spacing('xs')};
      height: ${spacing('xs')};
      border-radius: ${radius('full')};
      background-color: ${color('midnight_300')};
      border: ${spacing('xs')} solid transparent;
      background-clip: padding-box;
      box-sizing: content-box;
      margin-right: ${spacing('xs')};
      transition: 0.3s;
    }

    &:hover {
      color: ${color('text_active')};
      cursor: pointer;

      &::before {
        border-color: ${color('midnight_700')};
      }
    }

    &.is-active {
      color: ${color('text_active')};
      font-weight: ${fontWeight('black')};

      &::before {
        background-color: ${color('active')};
        border-color: ${color('midnight_700')};
      }
    }
  }
`;
